export default function BlogDetail() {
    const h2Content = jQuery('.the-content h2');
    const tableOfContent = jQuery('.table-of-content ul');
    const socialMobileTrigger = jQuery('.social-mobile-trigger');
    const toggleScroll2ContactForm = jQuery('.js-toggle-scroll2-contact-form');
    const contactForm = jQuery('.global-contact-form');
    const tableList = jQuery('.the-content table');
    const btnClipBoard = jQuery('#btn-clipboard');

    this.init = () => {
        this.populateTableOfContent();
        this.socialMobileHandle();
        this.scrollToContactForm();
        this.tableScrollVerticalHandle();
        this.clipBoard();
    };

    this.populateTableOfContent = () => {
        h2Content.each(function name(index, h2) {
            jQuery(h2).attr('scroll-target', 'block-' + index);

            let active = (index === 0) ? 'active' : '';
            tableOfContent.append('<li><div class="item '+ active +'" scroll-trigger="block-' + index + '">'+ jQuery(h2).text() +'</div></li>')
        }).promise().done(function () {
            const scrollTrigger = jQuery("*[scroll-trigger]");
            tableOfContentTrigger1(scrollTrigger);
        });
    }

    function tableOfContentTrigger1(scrollTrigger) {
        scrollTrigger.on('click', function(e) {
            e.preventDefault();
            const triggerAttr = jQuery(this).attr('scroll-trigger');
            const scrollTarget = jQuery('*[scroll-target=' + triggerAttr + ']');

            scrollTrigger.removeClass('active');
            jQuery(this).addClass('active');

            jQuery('html, body').stop().animate({
                scrollTop: scrollTarget.offset().top - 0
            }, 600 );

            return false;
        });

        jQuery(window).on('scroll', function() {
            const scrollPosition = jQuery(window).scrollTop();

            scrollTrigger.each(function() {
                const triggerAttr = jQuery(this).attr('scroll-trigger');
                const scrollTarget = jQuery('*[scroll-target=' + triggerAttr + ']');

                if ((scrollTarget.offset().top - jQuery(window).height() / 2) <= scrollPosition) {
                    scrollTrigger.removeClass('active');
                    jQuery(this).addClass('active');
                }
            });
        });
    }

    this.socialMobileHandle = () => {
        socialMobileTrigger.on('click', function(e) {
            e.preventDefault();
            jQuery(this).parent().toggleClass('active');
        });

        jQuery(window).on('scroll', () => {
            let top = jQuery(window).scrollTop();
            if(top > 100) {
                socialMobileTrigger.parent().fadeIn();
            } else {
                socialMobileTrigger.parent().fadeOut();
            }
        })
    }

    this.scrollToContactForm = () => {
        const offsetContactForm = contactForm.offset().top;
        jQuery(toggleScroll2ContactForm).on('click', (e)=> {
            e.preventDefault();
            jQuery("html, body").animate({
                scrollTop: offsetContactForm
            }, "slow");
            return false;
        })
    }

    this.tableScrollVerticalHandle = () => {
        tableList.each(function() {
            if (!jQuery(this).parent().is('div[style="overflow-x:auto;"]')) {
                jQuery(this).wrap('<div class="scroll" style="overflow-x:auto;"></div>');
            }
        });
    }

    this.clipBoard = () => {
        btnClipBoard.on('click', function () {
            const text = jQuery(this).data('url');
            const tempInput = jQuery("<input>");

            jQuery(this).append(tempInput);
            tempInput.val(text).select();
            document.execCommand("copy");
            tempInput.remove();

            jQuery(".copied")
                .animate({opacity: 1}, 500)
                .animate({opacity: 0}, 2500)
            ;
        });
    }
}

new BlogDetail().init();